"use strict";function getRealmCid$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getRealmCid$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.getRealmCid";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.7.12"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.7.12"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.7.12"},_a)),exports.getRealmCid$=getRealmCid$,exports.default=getRealmCid$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/getRealmCid.js
// module id = 917
// module chunks = 106